import React from "react";
import { View, Text, Modal, TouchableOpacity, StyleSheet } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

interface TokenBalanceInfoPopupProps {
  visible: boolean;
  onClose: () => void;
}

const TokenBalanceInfoPopup = ({ visible, onClose }) => {
  const styles = useStyles();
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.container}>
          <View style={styles.header}>
            <Text style={styles.title}>What are tokens?</Text>
            <TouchableOpacity onPress={onClose}>
              <Text style={styles.closeButton}>✖</Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.text}>
            Tokens are a higher-tier currency, often premium, used for special
            features or items.
          </Text>
          <Text style={styles.subheading}>Usage:</Text>
          <Text style={styles.text}>
            <Text style={styles.bold}>Unlock Premium Features:</Text> Used to
            access exclusive tournaments, events, or in-platform perks.
          </Text>
          <Text style={styles.text}>
            <Text style={styles.bold}>Purchase Premium Items:</Text> Can be
            spent on rare avatars, special effects, or unique badges.
          </Text>
          <Text style={styles.text}>
            <Text style={styles.bold}>Exchange for Real Rewards:</Text> If the
            platform integrates real-world rewards (e.g., gift cards, cash
            equivalents), tokens might be the currency for such exchanges.
          </Text>
        </View>
      </View>
    </Modal>
  );
};

export default TokenBalanceInfoPopup;

const useStyles = CreateResponsiveStyle(
  {
    overlay: {
      flex: 1,
      left: "74%",
      top: "19%",
    },
    container: {
      backgroundColor: "#000",
      padding: 20,
      borderRadius: 10,
      width: "90%",
      maxWidth: 400,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",

      marginBottom: 10,
    },
    title: {
      fontSize: 18,
      fontWeight: "bold",
      color: "#fff",
    },
    closeButton: {
      color: "#fff",
      fontSize: 18,
    },
    text: {
      fontSize: 14,
      color: "#fff",
      marginBottom: 8,
    },
    subheading: {
      fontSize: 16,
      fontWeight: "bold",
      color: "#fff",
      marginTop: 10,
    },
    bold: {
      fontWeight: "bold",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      overlay: {
        left: "8%",
        top: "20%",
      },
      container: {
        padding: 10,
        width: "84%",
      },
    },
    [DEVICE_SIZES.SM]: {
      overlay: {
        left: "26%",
        top: "17%",
      },
      container: {
        padding: 10,
        maxWidth: 367,
      },
    },
    [DEVICE_SIZES.LG]: {
      overlay: {
        left: "26%",
        top: "13%",
      },
      container: {
        padding: 10,
        maxWidth: 485,
      },
    },
  }
);
